






















import Vue from "vue";
import { PropType } from "vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import LayoutColumnSingle from "@/components/Atoms/Layout/ColumnSingle/index.vue";
import EventHeader from "@/components/Molecules/EventHeader/index.vue";
import EventDetailContents from "@/components/Pages/EventDetail/Molecules/EventDetailContents/index.vue";
import ClipMixin from "@/components/Mixins/Clip/index";

import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventDetail",
  components: {
    LoadingView,
    LayoutColumnSingle,
    EventHeader,
    EventDetailContents
  },
  mixins: [ClipMixin],
  props: {
    eventDetail: {
      type: Object as PropType<Props["eventDetail"]>,
      default: undefined
    },
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    isLoading: {
      type: Boolean as PropType<Props["isLoading"]>,
      required: true
    }
  },
  methods: {
    toggleClipped(clipped) {
      if (!this.eventDetail) return;
      if (clipped) {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).createClip({
          event_detail_id: this.eventDetail.id,
          experience_id: null
        });
      } else {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).deleteClip({
          clip_id: this.eventDetail.clip_id
        });
      }
    }
  }
});
